import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { NegativeComparerPipe } from './pipes/negative-comparer.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { LoaderSpinnerComponent } from './components/loader-spinner/loader-spinner.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { MAT_LEGACY_CHECKBOX_DEFAULT_OPTIONS as MAT_CHECKBOX_DEFAULT_OPTIONS, MatLegacyCheckboxDefaultOptions as MatCheckboxDefaultOptions } from '@angular/material/legacy-checkbox';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatIconModule } from '@angular/material/icon';
import { MatStepperModule } from '@angular/material/stepper';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatListModule } from '@angular/material/list';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSortModule } from '@angular/material/sort';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatChipsModule } from '@angular/material/chips';
import { MatTableModule } from '@angular/material/table';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { MenuModule } from 'primeng/menu';
import { PanelMenuModule } from 'primeng/panelmenu';
import { DialogModule } from 'primeng/dialog';
import { PanelModule } from 'primeng/panel';
import { CalendarModule } from 'primeng/calendar';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ProgressBarModule } from 'primeng/progressbar';
import { OrderListModule } from 'primeng/orderlist';
import { SplitButtonModule } from 'primeng/splitbutton';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TreeModule } from 'primeng/tree';
import { StepsModule } from 'primeng/steps';
import { ContextMenuModule } from 'primeng/contextmenu';
import { TabViewModule } from 'primeng/tabview';
import { CheckboxModule } from 'primeng/checkbox';
import { TreeTableModule } from 'primeng/treetable';
import { SpinnerModule } from 'primeng/spinner';
import { InputSwitchModule } from 'primeng/inputswitch';
import { SidebarModule } from 'primeng/sidebar';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

import { environment } from 'src/environments/environment';
import { NumberFormatterDirective, NumberDirective, PositiveNumberDirective } from './directives/number.directive';
import { InputTextModule } from 'primeng/inputtext';
import { GlobalFilterComponent } from './components/global-filter/global-filter.component';
import { GenericNgTableComponent } from "./components/generic-ng-table/generic-ng-table.component";
import { GlobalFilterService } from './services/global-filter.service';
import { ProductionPlanningService } from 'src/app/tools/services/production-planning.service';
import { ProductionPlanningDataService } from 'src/app/tools/services/production-planning-data.service';
import { NumberFormatterPipe } from "./pipes/number-formatter.pipe";

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, `./assets/${environment.context_root}i18n/`, '.json');
}

@NgModule({
  declarations: [
    PageNotFoundComponent,
    SafeHtmlPipe,
    UnauthorizedComponent,
    LoaderSpinnerComponent,
    NegativeComparerPipe,
    NumberFormatterDirective,
    NumberDirective,
    PositiveNumberDirective,
    GlobalFilterComponent,
    GenericNgTableComponent,
    NumberFormatterPipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSidenavModule,
    MatBadgeModule,
    MatIconModule,
    MatDialogModule,
    MatButtonModule,
    MatSelectModule,
    MatFormFieldModule,
    MatButtonToggleModule,
    DragDropModule,
    TableModule,
    ButtonModule,
    DropdownModule,
    MultiSelectModule,
    SplitButtonModule,
    MenuModule,
    PanelMenuModule,
    PanelModule,
    TabViewModule,
    ProgressBarModule,
    CalendarModule,
    DialogModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      isolate: false,
    }),
    AutoCompleteModule,
    OrderListModule,
    MatStepperModule,
    SidebarModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatMenuModule,
    MatSlideToggleModule,
    MatListModule,
    MatPaginatorModule,
    MatChipsModule,
    MatTableModule,
    ButtonModule,
    MatCardModule,
    MatInputModule,
    NgxMatSelectSearchModule
  ],
  exports: [
    MatDatepickerModule,
    MatNativeDateModule,
    MatSidenavModule,
    MatBadgeModule,
    MatIconModule,
    MatDialogModule,
    MatButtonModule,
    MatSelectModule,
    MatFormFieldModule,
    MatButtonToggleModule,
    DragDropModule,
    FormsModule,
    ReactiveFormsModule,
    PageNotFoundComponent,
    UnauthorizedComponent,
    LoaderSpinnerComponent,
    SafeHtmlPipe,
    TranslateModule,
    TableModule,
    TreeModule,
    SelectButtonModule,
    PanelModule,
    DropdownModule,
    MultiSelectModule,
    SplitButtonModule,
    MenuModule,
    PanelMenuModule,
    DialogModule,
    ProgressBarModule,
    TabViewModule,
    CalendarModule,
    AutoCompleteModule,
    OrderListModule,
    NegativeComparerPipe,
    NumberFormatterDirective,
    NumberDirective,
    PositiveNumberDirective,
    StepsModule,
    OverlayPanelModule,
    MatExpansionModule,
    MatSortModule,
    ContextMenuModule,
    CheckboxModule,
    TreeTableModule,
    SpinnerModule,
    InputSwitchModule,
    SidebarModule,
    InputTextModule,
    MatStepperModule,
    GlobalFilterComponent,
    GenericNgTableComponent,
    NumberFormatterPipe,
    MatCheckboxModule,
    MatTooltipModule,
    MatMenuModule,
    MatSlideToggleModule,
    MatListModule,
    MatPaginatorModule,
    MatChipsModule,
    MatTableModule,
    MatCardModule,
    MatInputModule,
    NgxMatSelectSearchModule
  ],
  providers: [
    { provide: MAT_CHECKBOX_DEFAULT_OPTIONS, useValue: { clickAction: 'check' } as MatCheckboxDefaultOptions },
    ProductionPlanningService,
    ProductionPlanningDataService,
    GlobalFilterService
  ],
})
export class SharedModule { }
